// extracted by mini-css-extract-plugin
export default {"tagBlock":"TagsBlock_tagBlock__ZgG0w","titleCategory":"TagsBlock_titleCategory__ZMDH3"};